import { useMasterDataProductCategories } from "@src/presentation/providers/MasterDataProductCategoriesDataProvider";
import { MasterDataListFooter } from "./MasterDataListFooter";

export const MasterDataProductCategoriesFooter = () => {
  const { total, page, limit, loading, setPage } =
    useMasterDataProductCategories();

  return (
    <MasterDataListFooter
      total={total}
      page={page}
      limit={limit}
      loading={loading}
      onPageChange={setPage}
      ariaLabel="Product Categories Pagination"
    />
  );
};
